import { Container, Form, Row } from "react-bootstrap";
import AddNewMargin from "../modal/AddNewMargin";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import MarginCalculatorHeader from "../components/MarginCalculatorHeader";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/free-solid-svg-icons";
import MarginCalculatorStockMovement from "../components/MarginCalculatorStockMovement";
import MarginCalculatorGeneralFeeRate from "../components/MarginCalculatorGeneralFeeRate";
import MarginCalculatorResult from "../components/MarginCalculatorResult";
import { useDispatch, useSelector } from "react-redux";
import * as movementSelectors from "../../../selectors/movement";
import { useForm } from "react-hook-form";
import Helper from "../../../utils/Helper";
import * as movementActions from "../../../action/movement";
import Constants from "../../../constants";
import _ from "lodash";
import CustomConfirmationModal from "../../../components/CustomConfirmationModal";
import * as userSelectors from "../../../selectors/user";
import { withTransactionCostConfig } from "../../../hooks/withTransactionCostConfig";
import * as toolSelectors from "../../../selectors/tool";
import { useQuery } from "@tanstack/react-query";
import * as axiosInstance from "../../../services/axiosInstance";
import {
  getMarginConfigBeforeMarginAmount,
  getMarginConfigBeforeMarketValue,
  getMarginConfigStockMovement,
  getToolItemCapPrice,
} from "../../../selectors/tool";
function MarginSimulator({ configData }) {
  const [show, setShow] = useState(false);
  const [confirmDeleteShow, setConfirmDeleteShow] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [shareMovement, setShareMovement] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [outcome, setOutCome] = useState(null);
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.user);
  const accountSelections = userSelectors.getUserAccountIsSelectedText(userState);
  const clientName = userSelectors.getUserName(userState);
  const share_movement_list = useSelector((state) => movementSelectors.getMovementList(state.movement));

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    reset,
    setValue,
    watch,
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onSubmit",
    // reValidateMode: "onChange",
    defaultValues: {
      mof: toolSelectors.getConfigMofValue(configData),
      outstanding_amount: "0",
      margin_value: "0",
      market_value: "0",
      brokerage_under_rate: toolSelectors.getConfigBrokerageUnderRateValue(configData),
      brokerage_over_rate: toolSelectors.getConfigBrokerageOverRateValue(configData),
      min_brokerage: toolSelectors.getConfigMinBrokerageValue(configData),
      clearing_fee_rate: toolSelectors.getConfigClearingFeeValue(configData),
      max_clearing_fee: toolSelectors.getConfigMaxClearingFeeValue(configData),
      intraday_rate: toolSelectors.getConfigIntraDayRateValue(configData),
      stamp_duty: toolSelectors.getConfigStampDutyValue(configData),
      max_stamp_duty: toolSelectors.getConfigMaxStampDutyValue(configData),
      stamp_duty_ws: toolSelectors.getConfigStampDutyWarrantValue(configData),
      max_stamp_duty_ws: toolSelectors.getConfigMaxStampDutyWarrantValue(configData),
      sst: toolSelectors.getConfigSSTValue(configData),
    },
  });

  const { isLoading, data } = useQuery({
    queryKey: ["margin-simulator-config"],
    queryFn: async () => {
      try {
        return await axiosInstance.get(`/clientarea/margin-simulator`);
      } catch (e) {}
    },
    retryDelay: 15000,
  });

  useEffect(() => {
    const outstanding_amount = toolSelectors.getMarginConfigBeforeOutstandingAmount(data);
    const margin_value = toolSelectors.getMarginConfigBeforeMarginAmount(data);
    const market_value = toolSelectors.getMarginConfigBeforeMarketValue(data);
    const stockMovement = toolSelectors.getMarginConfigStockMovement(data);
    setValue("outstanding_amount", outstanding_amount);
    setValue("margin_value", margin_value);
    setValue("market_value", market_value);
    const newStockMovement = _.map(stockMovement, (item) => {
      const capPrice = toolSelectors.getToolItemCapPrice(item);
      const isExisting = toolSelectors.getToolItemQIsExisting(item);
      const marginAmount = toolSelectors.getToolItemMarginAmount(item);
      const marketValue = toolSelectors.getToolItemMarketValue(item);
      const mof = toolSelectors.getToolItemMof(item);
      const outstandingAmount = toolSelectors.getToolItemOutstandingAmount(item);
      const price = toolSelectors.getToolItemPrice(item);
      const quantity = toolSelectors.getToolItemQuantity(item);
      const stockCode = toolSelectors.getToolItemStockCode(item);
      const stockName = toolSelectors.getToolItemStockName(item);
      return {
        stock_cap_price: capPrice,
        action_type: "Existing",
        is_existing: isExisting,
        margin_amount: marginAmount,
        market_value: marketValue,
        stock_mof: mof,
        amount: outstandingAmount,
        stock_price: price,
        stock_quantity: quantity,
        stock_code: stockCode,
        stock_name: stockName,
      };
    });
    if (!_.isEmpty(newStockMovement)) {
      dispatch(movementActions.addExistingMovement(newStockMovement));
    }
  }, [data]);

  const handleActionFormSubmit = (values) => {
    if (values.action_type === Constants.CASH_IN || values.action_type === Constants.CASH_OUT) {
      values = _.omit(values, [
        "stock_code",
        "stock_name",
        "stock_quantity",
        "stock_price",
        "stock_mof",
        "stock_cap_price",
        "margin_amount",
      ]);
    }
    if (values.action_type === Constants.TRANSFER_OUT || values.action_type === Constants.TRANSFER_IN) {
      values = _.omit(values, ["amount", "margin_amount"]);
    }
    if (editIndex === null) {
      dispatch(movementActions.addNewMovementRequest(values));
      setValue("action_type", 0);
    } else {
      dispatch(movementActions.putUpdateMovementRequest(values, editIndex));
    }
    setShow(false);
  };

  const startCalculate = useCallback(() => {
    const valueMof = getValues("mof");
    const mof = valueMof > 0 ? valueMof / 100 : 0;
    const valueOutstandingAmount = getValues("outstanding_amount");
    const valueMarketValue = getValues("market_value");
    const valueMarginValue = getValues("margin_value");

    const outstanding_amount = valueOutstandingAmount;
    const market_value =
      Helper.roundToDecimals(valueMarketValue) > 0 ? Helper.roundToDecimals(valueMarketValue) : 0;
    const margin_value =
      Helper.roundToDecimals(valueMarginValue) > 0 ? Helper.roundToDecimals(valueMarginValue) : 0;

    let market_value_after = 0;
    let os_amount_after = 0;
    let margin_value_after = 0;
    let position_before = 0;
    let position_after = 0;

    for (let i = 0; i < share_movement_list.length; i++) {
      const current = share_movement_list[i];
      let osAmount = 0;
      if (current.action_type === Constants.BUY_IN || current.action_type === Constants.SELL_OUT) {
        osAmount = _.ceil(current.amount, 2);
      }

      const iShareMarket = (
        parseFloat(current.stock_price) *
        (parseFloat(current.stock_quantity) * 100)
      ).toFixed(2);
      const iShareMargin =
        current.stock_cap_price != 0 &&
        current.stock_cap_price !== null &&
        current.stock_cap_price !== "" &&
        current.stock_cap_price < current.stock_price
          ? parseFloat(current.stock_cap_price) *
            parseFloat(current.stock_quantity) *
            parseFloat(current.stock_mof)
          : parseFloat(current.stock_price) *
            parseFloat(current.stock_quantity) *
            parseFloat(current.stock_mof);

      if (current.action_type === Constants.SELL_OUT) {
        os_amount_after -= osAmount;
        market_value_after += iShareMarket;
        margin_value_after += iShareMargin;
      } else if (current.action_type === Constants.BUY_IN) {
        os_amount_after -= osAmount;
        market_value_after -= iShareMarket;
        margin_value_after -= iShareMargin;
      } else if (current.action_type === Constants.TRANSFER_OUT) {
        os_amount_after -= osAmount;
        market_value_after += iShareMarket;
        margin_value_after += iShareMargin;
      } else if (current.action_type === Constants.TRANSFER_IN) {
        os_amount_after += osAmount;
        market_value_after -= iShareMarket;
        margin_value_after -= iShareMargin;
      } else if (current.action_type === Constants.CASH_IN) {
        os_amount_after -= parseFloat(current.amount);
      } else if (current.action_type === Constants.CASH_OUT) {
        os_amount_after += parseFloat(current.amount);
      }
    }
    // total share amount

    // const outstanding_amount_after =
    //     Helper.roundToDecimals(outstanding_amount) + Helper.roundToDecimals(totalShareAmount);
    // const market_value_after =
    //     Helper.roundToDecimals(market_value) + Helper.roundToDecimals(totalShareMarketValue);
    // const margin_value_after =
    //     Helper.roundToDecimals(margin_value) + Helper.roundToDecimals(totalShareMarginValue);

    position_before = margin_value > 0 ? (outstanding_amount / margin_value) * 100 : 0;

    os_amount_after = parseFloat(outstanding_amount) - parseFloat(os_amount_after);
    margin_value_after = parseFloat(margin_value) - parseFloat(margin_value_after);
    market_value_after = parseFloat(market_value) - parseFloat(market_value_after);

    position_after = _.round((os_amount_after / margin_value_after) * 100, 2);
    let available_limit = 0;
    available_limit = (mof * margin_value_after + os_amount_after) / (1 - mof);
    available_limit = available_limit <= 0 ? 0 : available_limit;
    let max_top_up_cash = 0;
    max_top_up_cash = mof * margin_value_after + os_amount_after;
    max_top_up_cash = max_top_up_cash <= 0 ? Math.abs(max_top_up_cash) : 0;
    let share_to_sell = 0;
    share_to_sell = (os_amount_after + mof * margin_value_after) / (1 - mof);
    share_to_sell = share_to_sell > 0 ? 0 : share_to_sell;
    let max_withdrawal = 0;
    let tempWithdrawCash =
      Math.abs(position_after) < mof * 100 ? false : mof * margin_value_after + os_amount_after <= 0;

    max_withdrawal = tempWithdrawCash ? 0 : mof * margin_value_after + os_amount_after;

    position_before = Math.abs(position_before);
    position_after = Math.abs(position_after);
    let percentum = 0;
    percentum =
      outstanding_amount >= 0 ? 999.99 : _.round(Math.abs(market_value / outstanding_amount) * 100, 2);
    percentum = percentum > 999.99 ? 999.99 : percentum;
    let percentum_after = 0;
    percentum_after =
      os_amount_after >= 0 ? 999.99 : _.round(Math.abs(market_value_after / os_amount_after) * 100, 2);
    percentum_after = percentum_after > 999.99 ? 999.99 : percentum_after;
    setOutCome({
      client_info: {
        mof: Number.isNaN(mof) ? 0 : mof,
        available_limit: _.ceil(available_limit, 2),
        top_up_cash: _.ceil(max_top_up_cash, 2),
        withdraw_client: _.ceil(max_withdrawal, 2),
        share_to_sell: _.ceil(share_to_sell, 2),
      },
      summary_position: {
        outstanding_amount: _.ceil(outstanding_amount, 2),
        outstanding_amount_after: _.ceil(os_amount_after, 2),
        market_value: _.ceil(market_value, 2),
        market_value_after: _.ceil(market_value_after, 2),
        margin_value: _.ceil(margin_value, 2),
        margin_value_after: _.ceil(margin_value_after, 2),
        position: _.ceil(position_before, 2),
        position_after: _.ceil(position_after, 2),
        percentum: _.ceil(percentum, 2),
        percentum_after: _.ceil(percentum_after, 2),
      },
    });
  }, [share_movement_list]);

  useEffect(() => {
    setShareMovement((prev) => {
      if (prev !== share_movement_list) {
        return share_movement_list;
      } else {
        return prev;
      }
    });
  }, [share_movement_list]);

  useEffect(() => {
    startCalculate();
  }, [shareMovement]);

  const onClickDeleteMovement = (item, index) => {
    setConfirmDeleteShow(true);
    setDeleteIndex(index);
  };

  const onClickEditMovement = (item, index) => {
    setShow(true);
    setEditIndex(index);
    setValue("action_type", item.action_type);
    if (
      item.action_type === Constants.CASH_IN ||
      item.action_type === Constants.CASH_OUT ||
      item.action_type === Constants.BUY_IN ||
      item.action_type === Constants.SELL_OUT
    ) {
      setValue("amount", item.amount);
    }

    if (
      item.action_type === Constants.BUY_IN ||
      item.action_type === Constants.SELL_OUT ||
      item.action_type === Constants.TRANSFER_OUT ||
      item.action_type === Constants.TRANSFER_IN
    ) {
      setValue("stock_cap_price", item.stock_cap_price);
      setValue("stock_code", item.stock_code);
      setValue("stock_mof", item.stock_mof);
      setValue("stock_name", item.stock_name);
      setValue("stock_price", item.stock_price);
      setValue("stock_quantity", item.stock_quantity);
    }
  };

  const onDeleteConfirm = () => {
    dispatch(movementActions.deleteMovementRequest(deleteIndex));
    onHandleDeleteClose();
  };

  const handleClose = () => {
    setValue("action_type", 0);
    setEditIndex(null);

    setShow(false);
  };
  const onHandleDeleteClose = () => {
    setDeleteIndex(null);
    setConfirmDeleteShow(false);
  };

  return (
    <Container fluid>
      <Form onSubmit={handleSubmit(handleActionFormSubmit)}>
        <div className="mt-4">
          <MarginCalculatorHeader
            isMargin={true}
            name={clientName}
            account={accountSelections}
          ></MarginCalculatorHeader>
          <hr className="line-gold" />
          <div className={"primary-border-table-border"} style={{ backgroundColor: "white" }}>
            <div
              className={clsx(
                "d-flex custom-card-label-container align-items-center justify-content-between",
              )}
            >
              <div className={clsx("d-flex align-items-center")}>
                <FontAwesomeIcon
                  icon={faFileLines}
                  className="fa-2x"
                  style={{ marginRight: "10px", color: "white" }}
                />
                <h2>Margin Simulator</h2>
              </div>
              <button
                className={clsx("btn custom-button-primary")}
                onClick={() => setShow(true)}
                style={{ backgroundColor: "#9D7905" }}
              >
                Add New Movement
              </button>
            </div>
            <div className={clsx("custom-table-info-container padding-12px")}>
              <Row>
                <MarginCalculatorGeneralFeeRate
                  getValues={getValues}
                  register={register}
                  startCalculate={startCalculate}
                ></MarginCalculatorGeneralFeeRate>
                <MarginCalculatorResult
                  shareMovementList={share_movement_list}
                  handleShow={() => setShow(true)}
                  onClickDelete={onClickDeleteMovement}
                  onClickEdit={onClickEditMovement}
                  getValues={getValues}
                  outcome={outcome}
                ></MarginCalculatorResult>
              </Row>
            </div>
          </div>
        </div>
        <AddNewMargin
          getValues={getValues}
          setValue={setValue}
          reset={reset}
          handleSubmit={handleSubmit(handleActionFormSubmit)}
          register={register}
          show={show}
          watch={watch}
          isEdit={editIndex !== null}
          handleClose={handleClose}
        />
        <CustomConfirmationModal
          show={confirmDeleteShow}
          confirm={onDeleteConfirm}
          handleClose={onHandleDeleteClose}
          desc="Are you confirm to delete this movement?"
          title="Confirm Delete Modal"
        ></CustomConfirmationModal>
      </Form>
    </Container>
  );
}

export default withTransactionCostConfig(MarginSimulator);
